import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { Email } from "./email.model";
import { EmailListing } from "./email-listing.model";
import { handleError } from "../../shared/handle-error";

@Injectable()
export class EmailService {
    private enquiriesUrl = "api/enquiries";  // url to web api

    constructor(private http: HttpClient) { }

    getListing(enquiryID: number): Promise<EmailListing[]> {
        const url = `${this.enquiriesUrl}/${enquiryID}/emails`;
        return this.http.get<EmailListing[]>(url)
            .toPromise()
            .catch(handleError);
    }

    sendEmail(enquiryID: number, email: Email): Promise<void> {
        const url = `${this.enquiriesUrl}/${enquiryID}/emails`;
        return this.http.post(url, email)
            .toPromise()
            .catch(handleError);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/enquiry/shared/email.service.ts